import breakpoints from './breakpoints.json';

/**
 * Breakpoint pixel values. Single source of truth lives in
 * `constants/breakpoints.json`, which is also consumed by `tailwind.config.js`
 * (the CSS `sm:`/`md:`/… screens), so runtime width checks always match CSS.
 */
export const breakpointPx = breakpoints;

export class LayoutBreakpoints {
  /** Tablet/desktop threshold — matches the Tailwind `md` breakpoint. */
  public static readonly tablet = breakpoints.md;

  /** Wide/desktop threshold — matches the Tailwind `xl` breakpoint. */
  public static readonly desktop = breakpoints.xl;

  /**
   * Whether a viewport width is at or above a breakpoint. Inclusive at the exact
   * pixel value, mirroring CSS `min-width` media queries (so runtime conditional
   * rendering matches the Tailwind `md:`/`xl:` reveal it replaces).
   */
  public static isWidthUp(width: number, minWidth: number): boolean {
    return width >= minWidth;
  }
}
